import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';

import { httpErrorToastInterceptor } from '@echospaces-web-monorepo/es-shared-ui';

import { loadRuntimeConfig, provideEsAuth } from '@echospaces-web-monorepo/es-auth';
import { provideActiveCompany, providePortalApi } from '@echospaces-web-monorepo/es-portal-shell';

import { AppComponent } from './app/app';
import { appRoutes } from './app/app.routes';
import { environment } from './environments/environment';

// Fetch the per-silo runtime config from the co-located world-api at the
// same-origin `/api/config` BEFORE bootstrap, so ONE env-agnostic build/image
// configures its auth per deploy. Falls back to the build-time environment.ts
// (used only when that endpoint is unreachable, e.g. local `nx serve`).
loadRuntimeConfig({
  keycloakUrl: environment.keycloakUrl,
  realm: environment.realm,
  clientId: environment.clientId,
  apiUrl: environment.apiUrl,
}).then((rc) => {
  bootstrapApplication(AppComponent, {
    providers: [
      provideRouter(appRoutes),
      provideAnimations(),
      // The world BFF mounts the portal facade under `/api/portal` (member-admin
      // included — it proxies to the CC member API server-side; the SPA stays
      // same-origin).
      providePortalApi({ baseUrl: `${rc.apiUrl}/portal` }),
      // Badge which company this BFF is bound to (anti-mix-up in local CLI dev).
      provideActiveCompany(rc.company ?? null),
      provideEsAuth({
        keycloakUrl: rc.keycloakUrl,
        realm: rc.realm,
        clientId: rc.clientId,
        redirectUri: window.location.origin,
        postLogoutRedirectUri: window.location.origin,
        scope: 'openid profile email',
        httpInterceptors: [httpErrorToastInterceptor],
      }),
    ],
  }).catch((err) => console.error(err));
});
